export default function () {
  window.scrollTo(0, 0);
}
